export const filterMapping = {
  status: "status",
  kategoriPengajuan: "kategoriPengajuan",
  poktan: "poktanId",
  jenisTanaman: "jenisTanaman",
  jenisPupuk: "jenisPupuk",
  metodePengiriman: "metodePengiriman",
  kategoriAlsintan: "categoryAlsintanId",
  alsinstan: "alsintanId",
  roles: "roleId",
  users: "usersId",
  categoryArticle: "category",
  appType: "appType",
  jenisPerolehan: "jenisPerolehan",
  tanaman: "plantId",
} as const;

export type FilterKey = keyof typeof filterMapping;

export type Option = { label: string; value: string };
